/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_ListingInputs */

const en_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Listing`)
};

const es_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar anuncio`)
};

const fr_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer l'annonce`)
};

const de_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat verwalten`)
};

const ja_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品を管理`)
};

const zh_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理该商品`)
};

const ar_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة الإعلان`)
};

const id_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola Listing`)
};

const it_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci Annuncio`)
};

const ru_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление объявлением`)
};

const pt_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar Anúncio`)
};

const ko_manage_listing = /** @type {(inputs: Manage_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 관리`)
};

/**
* | output |
* | --- |
* | "Manage Listing" |
*
* @param {Manage_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const manage_listing = /** @type {((inputs?: Manage_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_listing(inputs)
	if (locale === "es") return es_manage_listing(inputs)
	if (locale === "fr") return fr_manage_listing(inputs)
	if (locale === "de") return de_manage_listing(inputs)
	if (locale === "ja") return ja_manage_listing(inputs)
	if (locale === "zh") return zh_manage_listing(inputs)
	if (locale === "ar") return ar_manage_listing(inputs)
	if (locale === "id") return id_manage_listing(inputs)
	if (locale === "it") return it_manage_listing(inputs)
	if (locale === "ru") return ru_manage_listing(inputs)
	if (locale === "pt") return pt_manage_listing(inputs)
	return ko_manage_listing(inputs)
});